(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial-slider-v2"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('@swiper-ready', () => {
    const { Swiper } = window;
    const $tcSwiper = document.querySelector('.tc-swiper');

    new Swiper($tcSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 32,
      threshold: 5,

      navigation: {
        nextEl: '.testimonial-arrows .swiper-btn-next',
        prevEl: '.testimonial-arrows .swiper-btn-prev',
        disabledClass: 'pointer-events-none opacity-50',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
